<mat-card class="filter settingHeader">
    <div class="name">
        Add Facility Request
    </div>
    <div class="quickAction">
        <mat-form-field class="example-form-field" appearence="fill" >
            <mat-label>Search Facility</mat-label>
            <input matInput type="text" >            
          </mat-form-field>
        <!-- <div class="">
            <button mat-flat-button color="primary" (click)="openCaseDetail()" > Add Equipment </button>
        </div> -->
    </div>
</mat-card>

<div class="listingHolder">
    <table class="table">
        <tr>
            <th>Facility Name</th>
            <th class="">Scheduler Name</th>
            <th class="" >Scheduler Email</th>
            <th class="" >Facility Phone Number</th>
            <th class="action" >Action</th>
        </tr>
        <tr>
            <td>David Williams - Heart Surgery</td>
            <td>Matt Mcalpin</td>
            <td>matt@flowtrics.com</td>
            <td>98458798589</td>
            <td>
                <div class="btnAction">
                    
                    <button mat-icon-button color="primary" matTooltipClass="tooltip"
                    matTooltip="Approve Request" >
                        <mat-icon>check_circle_outline</mat-icon>
                    </button>

                    <button mat-icon-button matTooltipClass="tooltip"
                    matTooltip="Reject Request" color="warn"  >
                        <mat-icon>thumb_down_off_alt</mat-icon>
                    </button>

                    
                </div>
            </td>
        </tr>
    </table>
</div>

